export const INFORMATION_LINK =
  'https://www.garance.com/politique-de-confidentialite';
export const SUBSCRIBE_LINK =
  'https://souscription.garance.com/VIVACITE/simulation/introduction';
